import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";  

export const ActiveApi = createApi({
  reducerPath: "activeExporter",
  baseQuery,   
  tagTypes: ["activeExporter","activeImporter"],
  endpoints: (builder) => ({
    inActiveExporter: builder.mutation({
      query: ({ id, remarks }) => ({
        url: `/export/status/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: {remarks:remarks}, 
      }),
      invalidatesTags: ["activeExporter"],
    }),
    inActiveImporter : builder.mutation({
      query: ({ id, remarks }) => ({
        url: `/import/status/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: {remarks:remarks}, 
      }),
      invalidatesTags: ["activeImporter"],
    })
  }),
});

export const {
    useInActiveExporterMutation,
    useInActiveImporterMutation
} = ActiveApi;
